import "./BusinessProgress.css";

function BusinessProgress({ stats = {}, provider }) {
  const providerType = provider?.providerType;

  const getInventoryLabel = () => {
    switch (providerType) {
      case "Bakery":
        return "First Product Added";

      case "Restaurant":
        return "First Menu Added";

      case "Hotel":
        return "First Menu Added";

      case "Catering":
        return "First Package Added";

      case "Provision Store":
        return "First Item Added";

      default:
        return "First Food Added";
    }
  };

  const hasInventory = () => {
    switch (providerType) {
      case "Bakery":
        return (stats.totalProducts || 0) > 0;

      case "Restaurant":
      case "Hotel":
        return (stats.totalFoods || 0) > 0;

      case "Catering":
        return (stats.totalPackages || 0) > 0;

      case "Provision Store":
        return (stats.totalItems || 0) > 0;

      default:
        return (stats.totalFoods || 0) > 0;
    }
  };

  const steps = [
    {
      label: "Business Registered",
      completed: true,
    },
    {
      label: "Business Profile Completed",
      completed: true,
    },
    {
      label: getInventoryLabel(),
      completed: hasInventory(),
    },
    {
      label: "First Order Received",
      completed: (stats.totalOrders || 0) > 0,
    },
    {
      label: "First Rating Received",
      completed: (stats.rating || 0) > 0,
    },
  ];

  const completedCount = steps.filter((step) => step.completed).length;

  const progress = Math.round(
    (completedCount / steps.length) * 100
  );

  return (
    <div className="business-progress">

      <div className="progress-header">
        <h2>📈 Business Progress</h2>
        <span>{progress}% Complete</span>
      </div>

      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{
            width: `${progress}%`,
          }}
        />
      </div>

      <div className="progress-list">
        {steps.map((step, index) => (
          <div
            className="progress-item"
            key={index}
          >
            <span
              className={
                step.completed
                  ? "done"
                  : "pending"
              }
            >
              {step.completed ? "✔" : "○"}
            </span>

            <p>{step.label}</p>
          </div>
        ))}
      </div>

    </div>
  );
}

export default BusinessProgress;